export default function(context) {
	context.store.commit('UPDATE_PAGE', {
		path : context.route.path,
		name : context.route.name,
		slug : context.route.params.slug
	})
}